import { Feed } from 'feed'

import { DOMAIN } from '@/config/appConstants'
import { parseJSONTimestamp } from '@/lib/helpers/dateHelpers'
import { withSessionInServer } from '@/lib/helpers/nextHelpers'
import { getMetaData } from '@/models/Auth'
import { getApiChangelogs } from '@/models/Changelog'
import type { IRSSChangelog } from '@/types/changelog'

export const getServerSideProps = withSessionInServer(async (ctx, headers) => {
  const { query, pathname, res } = ctx

  const metaData = await getMetaData(query, pathname, headers)
  let changelogs: IRSSChangelog[] = []

  if (!metaData || !metaData.organization || metaData?.organization?.privacy) {
    res?.writeHead(302, {
      Location: `/404`,
    })
    res?.end()
    return {}
  }
  if (!metaData?.organization?.privacy) {
    try {
      changelogs = (await getApiChangelogs(headers)) || []
    } catch (err: any) {
      console.error('ERROR', err)
      changelogs = []
    }
  }

  const feed = new Feed({
    title: `${metaData.title} - ${metaData.organization.changelog_name}`,
    description: metaData.description,
    id: `${metaData.organization.home_page}/rss/changelog.xml`,
    link: metaData.organization.home_page,
    language: metaData.organization.locale,
    image: metaData.image,
    favicon: metaData.favicon,
    generator: `https://${DOMAIN}`,
    copyright: `All rights reserved 2022, ${metaData.title}`,
    feedLinks: {
      json: `${metaData.organization.home_page}/rss/changelog.xml`,
    },
  })

  changelogs.map((changelog) =>
    feed.addItem({
      title: changelog.title,
      id: `${metaData.organization.home_page}changelog/${changelog.slug}`,
      link: `${metaData.organization.home_page}changelog/${changelog.slug}`,
      description: changelog.description_html,
      date: parseJSONTimestamp(changelog.created_at),
    })
  )
  if (!!res && !res?.writableEnded) {
    res?.setHeader('Content-Type', 'text/xml')
    res?.write(feed.rss2())
    res?.end()
  } else {
    return {}
  }

  return {}
})

export default function ChangelogRss() {}
